import React, { useState, useEffect } from 'react';
import {
  MainComponent,
  Texts,
  Component2,
  InnerComponent,
  FooterPart,
  HeaderPart,
  SaveButton,
  Component1,
  Component4
} from '../style.js';
import { useTheme } from '@emotion/react';
import InputComponent from 'src/components/shared/Form/Input/index.js';
import theme, { palette, shadows } from 'src/config/theme.js';
import { alpha, Box } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { postClinicRequest, updateClinicByIdRequest, getClinicByIdRequest, getAllDoctorsRequest } from '../../../store/appActions.js';
import InputSelect from 'src/components/shared/Form/Select';

import ButtonComponent from 'src/components/shared/Button/index.js';
import { ReactComponent as CloseIcon } from '../../../../../assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../../assets/images/add-square.svg';
import { getUserFromToken } from 'src/DecodeToken.js';
import dayjs from 'dayjs';

import toast from 'src/utils/toast';
import useResponsive from 'src/components/hooks/useResponsive.js';


const validationSchema = Yup.object().shape({
  clinicName: Yup.string().required('clinic name is required'),
  address: Yup.string().required('address is required'),

});
// function AddClinic({ onClose, updateClinics, clinicId }) {
//   const { isMobile, isDesktop, isTablet } = useResponsive();
//   const theme = useTheme();
//   const dispatch = useDispatch();

//   const handleSubmit = async (values, { resetForm }) => {
//     const userId = getUserFromToken();
//     if (!userId) {
//       console('Failed to identify user. Please login again.', { variant: 'error' });
//       return;
//     }
//     try {
//       const clinicData = {
//         clinicName: values.clinicName,
//         address: values.address,
//         user: userId,
//       };

//       const response = await new Promise((resolve, reject) => {
//         dispatch(postClinicRequest(clinicData, resolve, reject));
//       });
//       console.log(`Clinic created successfully ${response.message}`);

//       updateClinics();
//       toast.success(response.message)

//       resetForm();
//       onClose();
//     } catch (error) {
//       console.log(error.message || 'Failed to add Staff', { variant: 'error' });
//     }
//   };
//   return (
//     <Formik
//       initialValues={{
//         clinicName: '',
//         address: '',

//       }}
//       validationSchema={validationSchema}
//       onSubmit={handleSubmit}
//     >
//       {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
//         <Form>
//           <>
//             <HeaderPart>
//               Edit Clinic
//               <CloseIcon
//                 width={isMobile || isTablet ? 18 : 24}
//                 height={isMobile || isTablet ? 18 : 24} onClick={onClose} style={{ cursor: 'pointer' }} />
//             </HeaderPart>
//             <MainComponent >
//               <Component1 sx={{ width: isMobile || isTablet ? '280px' : '404px' }}>
//                 <Texts>Clinic Name</Texts>
//                 <InputComponent
//                   name="clinicName"
//                   variant="outlined"
//                   placeholder="Enter Clinic Name"
//                   fullWidth
//                   value={values.clinicName}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                   error={touched.clinicName && Boolean(errors.clinicName)}
//                   helperText={touched.clinicName && errors.clinicName}
//                   sx={{
//                     backgroundColor: palette.gery.white,
//                     boxShadow: shadows[1],
//                     '& .MuiOutlinedInput-root': {
//                       padding: '10px 0px',
//                       borderRadius: '12px',
//                       height: '52px',
//                     },
//                     '& .MuiOutlinedInput-notchedOutline': {
//                       border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
//                     },
//                     "& .MuiInputBase-input.MuiOutlinedInput-input": {
//                       ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
//                     },
//                   }}
//                 />

//               </Component1>
//               <Component4>

//                 <Texts>Clinic Address</Texts>
//                 <InputComponent
//                   name="address"
//                   value={values.address}
//                   variant="outlined"
//                   placeholder="Enter"
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                   error={touched.address && Boolean(errors.address)}
//                   helperText={touched.address && errors.address}
//                   fullWidth
//                   multiline
//                   rows={4}
//                   sx={{
//                     backgroundColor: palette.gery.white,
//                     boxShadow: shadows[1],
//                     '& .MuiOutlinedInput-root': {
//                       padding: '16px 18px',
//                       borderRadius: '12px',
//                       height: '120px',
//                     },
//                     "& .MuiInputBase-input.MuiOutlinedInput-input": {
//                       ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
//                     },
//                   }}
//                 />

//               </Component4>
//             </MainComponent>
//             <FooterPart>
//               <ButtonComponent
//                 variant="none"
//                 startIcon={<CloseIcon
//                   width={isMobile || isTablet ? 18 : 24}
//                   height={isMobile || isTablet ? 18 : 24} sx={{ color: theme.palette.primary.main }} />}
//                 onClick={onClose}
//               >
//                 Cancel
//               </ButtonComponent>
//               <SaveButton
//                 type="submit"
//                 variant="outlined"
//                 startIcon={<AddIcon
//                   width={isMobile || isTablet ? 18 : 24}
//                   height={isMobile || isTablet ? 18 : 24} sx={{ color: theme.palette.primary.main }} />}
//               >
//                 Save
//               </SaveButton>
//             </FooterPart>
//           </>
//         </Form >
//       )
//       }
//     </Formik >
//   );
// }

function AddClinic({ onClose, updateClinics, clinicId }) {
  const { isMobile, isDesktop, isTablet } = useResponsive();
  const theme = useTheme();
  const dispatch = useDispatch();

  const [initialValues, setInitialValues] = useState({
    clinicName: '',
    address: '',
    doctors: [getUserFromToken()],
  });

  const [doctorOptions, setDoctorOptions] = useState([]);

  useEffect(() => {
    dispatch(getAllDoctorsRequest((res) => {
      if (res && Array.isArray(res)) {
        const options = res.map((doc) => ({
          label: doc.personalInfo?.fullName || 'Unnamed Doctor',
          value: doc.personalInfo?.user || doc.id || doc._id,
        })).filter(o => !!o.value);
        setDoctorOptions(options);
      }
    }, (err) => {
      console.error("Failed to load doctor options:", err);
    }));
  }, [dispatch]);

  useEffect(() => {
    if (clinicId) {
      dispatch(getClinicByIdRequest(clinicId, (res) => {
        const associatedDoctorIds = (res?.doctors || []).map((doc) => doc.id || doc._id || doc);
        setInitialValues({
          clinicName: res?.clinicName || '',
          address: res?.address || '',
          doctors: associatedDoctorIds.length > 0 ? associatedDoctorIds : [getUserFromToken()],
        });
      }));
    }
  }, [clinicId, dispatch]);

  const handleSubmit = async (values, { resetForm }) => {
    const userId = getUserFromToken();
    if (!userId) {
      toast.error('Failed to identify user. Please login again.');
      return;
    }

    const clinicData = {
      clinicName: values.clinicName,
      address: values.address,
      user: userId,
      doctors: values.doctors,
    };

    try {
      let response;

      if (clinicId) {

        response = await new Promise((resolve, reject) =>
          dispatch(updateClinicByIdRequest(clinicId, clinicData, resolve, reject))
        );
        toast.success(response?.message || "Clinic updated successfully");
      } else {

        response = await new Promise((resolve, reject) =>
          dispatch(postClinicRequest(clinicData, resolve, reject))
        );
        toast.success(response?.message || "Clinic added successfully");
      }

      updateClinics?.();
      resetForm();
      onClose();
    } catch (error) {
      toast.error(error.message || 'Failed to save clinic');
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
        <Form>
          <>
            <HeaderPart>
              Edit Clinic
              <CloseIcon
                width={isMobile || isTablet ? 18 : 24}
                height={isMobile || isTablet ? 18 : 24} onClick={onClose} style={{ cursor: 'pointer' }} />
            </HeaderPart>
            <MainComponent >
              <Component1 sx={{ width: isMobile || isTablet ? '280px' : '404px' }}>
                <Texts>Clinic Name</Texts>
                <InputComponent
                  name="clinicName"
                  variant="outlined"
                  placeholder="Enter Clinic Name"
                  fullWidth
                  value={values.clinicName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.clinicName && Boolean(errors.clinicName)}
                  helperText={touched.clinicName && errors.clinicName}
                  sx={{
                    backgroundColor: palette.gery.white,
                    boxShadow: shadows[1],
                    '& .MuiOutlinedInput-root': {
                      padding: '10px 0px',
                      borderRadius: '12px',
                      height: '52px',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                    },
                    "& .MuiInputBase-input.MuiOutlinedInput-input": {
                      ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                    },
                  }}
                />

              </Component1>
              <Component4>

                <Texts>Clinic Address</Texts>
                <InputComponent
                  name="address"
                  value={values.address}
                  variant="outlined"
                  placeholder="Enter"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.address && Boolean(errors.address)}
                  helperText={touched.address && errors.address}
                  fullWidth
                  multiline
                  rows={4}
                  sx={{
                    backgroundColor: palette.gery.white,
                    boxShadow: shadows[1],
                    '& .MuiOutlinedInput-root': {
                      padding: '16px 18px',
                      borderRadius: '12px',
                      height: '120px',
                    },
                    "& .MuiInputBase-input.MuiOutlinedInput-input": {
                      ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                    },
                  }}
                />

              </Component4>

              <Component4 sx={{ marginTop: '20px' }}>
                <Texts>Associated Doctors</Texts>
                <InputSelect
                  options={doctorOptions}
                  name="doctors"
                  multiple
                  variant="outlined"
                  value={values.doctors}
                  onChange={(selectedValue) => setFieldValue('doctors', selectedValue)}
                  showNone={false}
                  placeholder="Select Doctors"
                  sx={{
                    backgroundColor: palette.gery.white,
                    boxShadow: shadows[1],
                    '& .MuiOutlinedInput-root': {
                      padding: '10px 0px',
                      borderRadius: '12px',
                      height: '52px',
                    },
                    "& .MuiInputBase-input.MuiOutlinedInput-input": {
                      ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                    },
                  }}
                />
              </Component4>
            </MainComponent>
            <FooterPart>
              <ButtonComponent
                variant="none"
                startIcon={<CloseIcon
                  width={isMobile || isTablet ? 18 : 24}
                  height={isMobile || isTablet ? 18 : 24} sx={{ color: theme.palette.primary.main }} />}
                onClick={onClose}
              >
                Cancel
              </ButtonComponent>
              <SaveButton
                type="submit"
                variant="outlined"
                startIcon={<AddIcon
                  width={isMobile || isTablet ? 18 : 24}
                  height={isMobile || isTablet ? 18 : 24} sx={{ color: theme.palette.primary.main }} />}
              >
                Save
              </SaveButton>
            </FooterPart>
          </>
        </Form >
      )}
    </Formik>
  );
}



export default AddClinic;
